export const NotificationStatus = {
    Completed: "completed",
    Complete: "complete",
    Failed: "failed",
    InProgress: "in-progress",
    Pending: "pending",
    Aborted: "aborted"
} as const;

export const NotificationTypes = {
    BackgroundUpdate: "background-update",
    Download: "download",
    DownloadJob: "download-job",
    GenerateReport: "generate-report",
    Publish: "publish",
    Unpublish: "unpublish",
    FlashtalkingDownloadExcel: "PUBFT_DOWNLOAD_EXCEL",
    FlashtalkingDownloadAssets: "PUBFT_DOWNLOAD_ASSETS",
    PsdDownloader: "PsdDownloader",
    PlainlyBatchRender: "PLAINLY_BATCH_RENDER",
    Preflight: "Preflight",
    AdobeIndesignDownload: "ADOBE_INDESIGN_DOWNLOAD"
} as const;
